import React, { useState } from 'react'
import { UploadOutlined } from '@ant-design/icons'
import { Button, message, Upload, Form, Modal } from 'antd'
import axios from 'axios'
import Clipboard from 'clipboard'


const App = () => {
  const [fileList, setFileList] = useState([])
  const [uploading, setUploading] = useState(false)
  const [text, setText] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleUpload = () => {
    const formData = new FormData()
    fileList.forEach((file) => {
      formData.append('picture', file)
    })
    setUploading(true)
    // axios
    // 使用axios发送POST请求进行多文件上传
    axios
      .post('/ocr/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        setText(res.data.text)
        setIsModalOpen(true)
        message.success('上传成功')
      })
      .catch((error) => {
        message.error('上传失败')
        console.log(error)
      })
      .finally(() => {
        setUploading(false)
      })
  }
  // form回调方法
  const onFinish = (values) => {
    handleUpload()
  }
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }
  // Modal回调方法
  const handleOk = () => {
    const res = Clipboard.copy(text)
    if (res) {
      message.success('复制成功')
    }
    setIsModalOpen(false)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  // 上传按钮属性
  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file)
      const newFileList = fileList.slice()
      newFileList.splice(index, 1)
      setFileList(newFileList)
    },
    beforeUpload: (file) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        message.error('只能上传jpg或png格式!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        message.error('上传文件最大10MB!')
        return false
      }
      setFileList([file])
      return false
    },
    fileList
  }
  return (
    <>
      <Upload {...props}>
        <Button icon={<UploadOutlined />}>选取文件</Button>
      </Upload>
      <Form
        name="basic"
        labelCol={{
          span: 4
        }}
        wrapperCol={{
          span: 16
        }}
        style={{
          marginTop: '20px'
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          wrapperCol={{
            offset: 10,
            span: 4
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            disabled={fileList.length < 1}
            loading={uploading}
            style={{
              marginTop: 16
            }}
          >
            {uploading ? '上传中' : '开始上传'}
          </Button>
        </Form.Item>
      </Form>
      <Modal
        title="识别结果"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="复制并关闭"
        cancelText="取消"
      >
        <div>{text}</div>
      </Modal>
    </>
  )
}
export default App
